// @flow
/* eslint-disable no-use-before-define */

export type TripType = $Values<typeof TRIP_TYPE>
export type TripTypeName = $Keys<typeof TRIP_TYPE>

export const TRIP_TYPE = {
  PREBOOK: 'prebook',
  ON_DEMAND: 'ondemand',
  PUBLIC_TRANSPORTATION: 'public_transportation',
}

export default TRIP_TYPE
